// extracted by mini-css-extract-plugin
export default {"tooltip":"FP-z","arrow":"GP-z"};